export const promo = {
  newInPro: "Nyhet i Pro",
  newInPlus: "Nyhet i Plus",
  newInExpert: "Test · Nyhet i Expert",
  videoTitle: "Hur mycket är dina prylar värda?",
  videoText:
    "Filma ett rum, vi plockar ut allt av värde vi hittar. Du får en lista med uppskattade värden och färdiga annonsutkast.",
  videoBullet1: "Filma rummet, vi listar prylarna",
  videoBullet2: "Summan syns direkt, du väljer vad du säljer",
  videoCta: "Skanna en film",
  getPro: "Skaffa Pro",
  photoTitle: "Fota flera prylar på en gång",
  photoText:
    "Gå runt och fota, ladda upp upp till {{max}} bilder per omgång. Vi grupperar ihop bilderna som visar samma pryl och sätter ett uppskattat värde.",
  photoCta: "Fota prylarna",
  getPlus: "Skaffa Plus",
  deepTitle: "Djupskanning av en enskild pryl",
  deepText:
    "Vi gräver djupare: exakt modell, skick och verkliga slutpriser. Du får ett prisintervall att lita på och en färdig annonstext – innan du sätter pris.",
  deepCta: "Djupskanna en pryl",
  getExpert: "Skaffa Expert",
} as const;
